import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../constants';
import { OauthAEMConfig } from '../../../models';
import {
  ChangeUserPasswordInfo,
  CheckNewPassword
} from '../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class CheckNewPasswordService {
  checkNewPasswordHeader: HttpHeadersPayload = {
    'Content-Type': 'application/vnd.pingidentity.checkNewPassword+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  checkNewPassword = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    fieldValues: ChangeUserPasswordInfo
  ): Observable<CheckNewPassword> => {
    const getCheckNewPasswordUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const checkNewPasswordUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getCheckNewPasswordUrl
      }
    ];

    return new ApiBuilder<ChangeUserPasswordInfo, CheckNewPassword>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(checkNewPasswordUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(fieldValues)
      .httpHeaders(this.checkNewPasswordHeader)
      .errorHandler(this._errorHandler)
      .library('CHECK_NEW_PASSWORD_SERVICE')
      .withCredentials(true)
      .create();
  };
}
